// App.js
import "./App.css";
import React from "react";
import { RecoilRoot } from "recoil";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Router from "./router/router";
import LoginProcess from "./pages/login/loginProcess";

function App() {
  return (
    <RecoilRoot>
      <div className="App">
        <Router />
        <ToastContainer
          className="toast"
          position="top-center"
          autoClose={2000}
          hideProgressBar={true}
        />
        <LoginProcess />
      </div>
    </RecoilRoot>
  );
}

export default App;
